import { Connector } from "../../types";

export const ConnectorCard: React.FC<{
  connector: Connector;
  onConfigure: (id: string) => void;
  isSelected?: boolean;
  onSelect?: (connector: Connector) => void;
  onShowGuide?: (connector: Connector) => void;
}> = ({
  connector,
  isSelected = false,
  onSelect,
  onShowGuide,
}) => {
  const handleCardClick = () => {
    if (connector.disabled) return;
    onSelect?.(connector);
    onShowGuide?.(connector);
  };
  return (
    <div
      className={`bg-white dark:bg-gray-800 border p-6 rounded-lg ${connector.disabled ? "opacity-60 cursor-not-allowed" : "hover:shadow-md cursor-pointer"} ${
        isSelected
          ? "border-blue-500 dark:border-blue-400 ring-2 ring-blue-500 dark:ring-blue-400 ring-opacity-50"
          : "border-gray-200 dark:border-gray-700"
      }`}
      onClick={handleCardClick}
      title={connector.disabled ? "Coming soon — no working provider on this workspace yet" : undefined}
    >
      <div className="flex justify-between items-start gap-2 mb-4">
        <div className="flex items-center min-w-0 flex-1">
          {connector.icon && (
            <span className="text-2xl mr-3 shrink-0">{connector.icon}</span>
          )}
          <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 truncate">
            {connector.name}
          </h3>
        </div>
        <span className="text-sm bg-gray-100 dark:bg-gray-700 h-8 flex justify-center items-center px-2 text-[12px] rounded-full text-gray-900 dark:text-gray-100 shrink-0 whitespace-nowrap">
          {connector.type}
        </span>
      </div>

      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className={`w-2 h-2 rounded-full mr-2 ${connector.disabled ? "bg-gray-300 dark:bg-gray-600" : "bg-emerald-400"}`}></div>
          <span className="text-sm text-gray-600 dark:text-gray-400">{connector.disabled ? "Coming soon" : "Ready to connect"}</span>
        </div>
      </div>
    </div>
  );
};
 